'use client';

import { Button } from '@packages/shared/src/ui/Button/Button';

export const ResponsiveHeaderErrorFallback = () => (
  <div className="bg-color-error-light flex items-center justify-center p-0.5">
    <Button
      color="error"
      onClick={() => {
        window.location.reload();
      }}
      aria-label="Reload page"
    >
      <div className="icon-emp-load-reload h-4 w-4" />
    </Button>
  </div>
);
